import { z } from "zod";
import { ThirdPartyExportConfig } from "./third-party-config.ts";

export const ThirdPartyVideoDto = z.object({
  externalId: z.string(),
  videoExternalId: z.string(),
});

export const ThirdPartyEditorInfoDto = z.object({
  internalName: z.string(),
  displayName: z.string(),
  squareLogoSrc: z.string(),
  redirectUrl: z.string(),
  exportConfig: ThirdPartyExportConfig,
});

export type ThirdPartyVideoDto = z.infer<typeof ThirdPartyVideoDto>;
export type ThirdPartyEditorInfoDto = z.infer<typeof ThirdPartyEditorInfoDto>;
